import type { GetterTree } from 'vuex'
import type { RootState } from '@/store'
import type { DeviceIntervalsState } from './types'
import { DEVICE_INTERVALS_GETTERS, IntervalType } from './types'

interface IDeviceIntervalsGetters extends GetterTree<DeviceIntervalsState, RootState> {
  [DEVICE_INTERVALS_GETTERS.IS_APP_INTERVAL_ACTIVE](state: DeviceIntervalsState): boolean
  [DEVICE_INTERVALS_GETTERS.IS_MANAGE_DEVICES_INTERVAL_ACTIVE](state: DeviceIntervalsState): boolean
}

const getters: IDeviceIntervalsGetters = {
  [DEVICE_INTERVALS_GETTERS.IS_APP_INTERVAL_ACTIVE](state) {
    return state.activeIntervalType === IntervalType.APP
  },
  [DEVICE_INTERVALS_GETTERS.IS_MANAGE_DEVICES_INTERVAL_ACTIVE](state) {
    return state.activeIntervalType === IntervalType.MANAGE_DEVICES
  }
}

export default getters
